/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Search_Guides_What_Is_Gridcraft_Sections_2_Bullets_1Inputs */

const en_gc_search_guides_what_is_gridcraft_sections_2_bullets_1 = /** @type {(inputs: Gc_Search_Guides_What_Is_Gridcraft_Sections_2_Bullets_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculate results: use formulas for totals, comparisons and summaries. Begin with a result you can check by hand before relying on a larger model.`)
};

const zh_gc_search_guides_what_is_gridcraft_sections_2_bullets_1 = /** @type {(inputs: Gc_Search_Guides_What_Is_Gridcraft_Sections_2_Bullets_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`计算结果：使用公式生成合计、比较与汇总。先验证可以手算的小例子，再依赖更大的模型。`)
};

/**
* | output |
* | --- |
* | "Calculate results: use formulas for totals, comparisons and summaries. Begin with a result you can check by hand before relying on a larger model." |
*
* @param {Gc_Search_Guides_What_Is_Gridcraft_Sections_2_Bullets_1Inputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_search_guides_what_is_gridcraft_sections_2_bullets_1 = /** @type {((inputs?: Gc_Search_Guides_What_Is_Gridcraft_Sections_2_Bullets_1Inputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Search_Guides_What_Is_Gridcraft_Sections_2_Bullets_1Inputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_search_guides_what_is_gridcraft_sections_2_bullets_1(inputs)
	return zh_gc_search_guides_what_is_gridcraft_sections_2_bullets_1(inputs)
});
export { gc_search_guides_what_is_gridcraft_sections_2_bullets_1 as "gc.search_guides.what_is_gridcraft.sections.2.bullets.1" }